var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":"ویرایش پست"}}),(_vm.post)?_c('crud-generator',{attrs:{"fields":_vm.fields,"current-values":_vm.post,"name":"posts"},on:{"submit":_vm.submit}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }